import { FC } from "react";

import "@tennr/style/index.css";
import "./AmbassadorPage.css";

// Universal
import { Link } from "@tanstack/react-router";
import { Button } from "@tennr/frontend/components/Button";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { doubleQuote, singleQuote } from "@tennr/frontend/utils";

import { Heading } from "@tennr/frontend/components/Heading";
import { HorizontalMarquee } from "@tennr/frontend/components/HorizontalMarquee";
import { Card } from "@tennr/frontend/components/Card";
import { AshbySection } from "@tennr/frontend/sections/AshbySection/AshbySection";
import { CareersVideoSection } from "@tennr/frontend/sections/CareersVideoSection";
import { HeroSection } from "@tennr/frontend/sections/HeroSection";
import { TestimonialsSection } from "@tennr/frontend/sections/TestimonialsSection";
import { DeepDiveSection } from "@tennr/frontend/sections/DeepDiveSection";
import { HubspotForm } from "@tennr/frontend/components/BookDemoForm";
import { FormHeroSection } from "@tennr/frontend/sections/FormHeroSection";
import { PartnersMarquee } from "@tennr/frontend/sections/PartnersMarquee";

const pressCards = [
  {
    logoSrc: "/figma/img/award-top-40.png",
    logoAlt: "Intelligent Applications 40",
    awardTitle: "Top 40 Private Companies\n2024",
  },
  {
    logoSrc: "/figma/svg/forbes-logo.svg",
    logoAlt: "Forbes",
    awardTitle: "Cloud 100 Rising Stars\n2024",
  },
  {
    logoSrc: "/figma/img/award-promising-startups.png",
    logoAlt: "The Information",
    awardTitle: "50 Most Promising Startups\n2024",
  },
  {
    logoSrc: "/img/cb-insights-logo.png",
    logoAlt: "CB Insights",
    awardTitle: "CB Insights Digital\nHealth 50 2024",
  },
  {
    logoSrc: "/figma/img/award-top-40.png",
    logoAlt: "Intelligent Applications 40",
    awardTitle: "Top 40 Private Companies\n2024",
  },
  {
    logoSrc: "/figma/svg/forbes-logo.svg",
    logoAlt: "Forbes",
    awardTitle: "Cloud 100 Rising Stars\n2024",
  },
  {
    logoSrc: "/figma/img/award-promising-startups.png",
    logoAlt: "The Information",
    awardTitle: "50 Most Promising Startups\n2024",
  },
  {
    logoSrc: "/img/cb-insights-logo.png",
    logoAlt: "CB Insights",
    awardTitle: "CB Insights Digital\nHealth 50 2024",
  },
  {
    logoSrc: "/figma/img/award-top-40.png",
    logoAlt: "Intelligent Applications 40",
    awardTitle: "Top 40 Private Companies\n2024",
  },
  {
    logoSrc: "/figma/svg/forbes-logo.svg",
    logoAlt: "Forbes",
    awardTitle: "Cloud 100 Rising Stars\n2024",
  },
  {
    logoSrc: "/figma/img/award-promising-startups.png",
    logoAlt: "The Information",
    awardTitle: "50 Most Promising Startups\n2024",
  },
  {
    logoSrc: "/img/cb-insights-logo.png",
    logoAlt: "CB Insights",
    awardTitle: "CB Insights Digital\nHealth 50 2024",
  },
];

export const AmbassadorPage: FC = () => {
  
  return (
    <>
      <MetadataTags
        title="Ambassador | Tennr"
        description="Find and apply for open positions at Tennr. Meet our team, learn about our values, and check out the benefits and growth opportunities we offer."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="ambassador-page">
        <PageBackground bgImage="/img/ambassador-bg.jpg" bgImageVert="/img/ambassador-bg-mobile.jpg" />
        <HeroSection
          noAnimate={true}
          className="bottom-left"
          cmsContent={{
            heading: {
              title: "Work With Us", 
              heading: "Join the future of healthcare operations",
              body: "Help providers convert referrals and do what they do best.",
            }            
          }}
        >
          <p>If you’re smart, fast, and not afraid to speak your mind, you’ll fit right in. </p>   
        </HeroSection>
        <section className="partner-form">
          <FormHeroSection {...{
                      heading: {
                        title:"LET'S DO THIS",
                        heading:"Become a Tennr Partner",
                        className:"form-hero-title",
                        body:"Do you work with healthcare businesses that want to eliminate the friction in getting patients ready for care?",
                        variant:"hero",
                        width:550,
                        verticalAlign: 'top'
                      },
                      hubspotForm:{ 
                        portalId: "23158831", 
                        formId: "ad73a2c1-22c3-4737-baa5-1944023021d0",
                        region : "na1"
                      }
                    }} />
        </section>
        <section className="partners">
          <PartnersMarquee />
        </section>
        <section className="partner-accordian">
        <DeepDiveSection {...{
            heading: {
              heading:"Our Values",
              title:"HOW WE WORK",
              body:"We work hard, encourage strong perspectives, and are maniacally focused on reducing patient delays across the U.S. healthcare system.",
              color:"dark",
              variant:"section",
              width: 560
            },
            backgroundImage: '/img/careers-accordian-bg.png',
            items:[
              {
                title: "Cowboy",
                body:"You set the pace. Do the thing instead of just talking about it.",
                id: "Cowboy",
              },
              {
                title: "Conviction",
                body:"If it’s not a hell yes, it’s a hell no. We have zero interest in doing anything halfway. Whether we’re hiring a candidate, building a client diagram, or even buying team merch, we go all the way. We’re unrelenting (in a good way).",
                id: "Conviction",
              },
              {
                title: "Clarity",
                body:"Everything we do depends on clarity of thought, speech, and writing. Clear communication sets a strong foundation.",
                id: "Clarity",
              },
              {
                title: "Customer (and Problem) Obsessed",
                body:"We live and die by creating value for our customers and solving one of healthcare’s biggest problems. We don’t trust the smiling face or quiet Slack channel. A commercial nose is one that tracks only the scent of business ROI—or the stench of rabid failure to deliver real value. Picking up the scent of failure is even more important than the former.",
                id: "Customer (and Problem) Obsessed",
              },
              {
                title: "Confrontation",
                body:"Failure and real discomfort comes from what we ignore, not what we face head-on. If you believe we are ever on a path towards failure in any part of the business, discuss it with the right person directly and act decisively. We don’t wait.",
                id: "Confrontation",
              },
              {
                title: "Courage",
                body:"Attempting to communicate clearly, confront hard truths and failures, and face reality is a terrifying position for any social being. But everything we’re doing here is a leap of faith. It takes a lot of courage. Here, we want you to nurture it in yourself and encourage it in others.",
                id: "Courage",
              }
            ]
          }
        }/>
        </section>                        
        <section className="ambassador-testimonials">          
          <TestimonialsSection { ...{
            heading:{
              title:"TESTIMONIALS",
              heading:"Hear from our Ambassadors",
              body: "What it's like to work with our team."
            },
            testimonials:[
                {
                  quote: doubleQuote(
                    "After meeting Tennr last year at VGM Heartland, I was very excited to partner with them to offer their automation platform to all my DME and Sleep Clients. Tennr is the fastest growing company working to automate your business workflows and has exceeded my customers' expectations."
                  ),
                  image: "/img/chris-holt.png",
                  attributedTo: "Phil Kneifel",
                  attributedToTitle: "President at Midwest Medical",
                },
                {
                  quote: doubleQuote(
                    "Tennr’s machine learning solutions enable our members to achieve greater efficiency with less effort, allowing staff to be reallocated to more meaningful roles. Their innovative offerings drive productivity and foster significant growth for our members’ businesses."
                  ),
                  image: "/img/khalid-elawad.png",
                  attributedTo: "Dave Lyman",
                  attributedToTitle: "SVP of Customer Success at VGM & Associates ",
                },
                {
                  quote: doubleQuote("Tennr involves uncovering untapped opportunities within healthcare operations, such as optimizing patient flow, boosting revenue, and enhancing overall service delivery. By partnering with Tennr, I aim to provide data-driven insights and strategic recommendations to help clients leverage."),
                  image: "/img/sydney-gil.png", 
                  attributedTo: "Michael Kemp",      
                  attributedToTitle: "CEO at Kemp Holdings",
                },
              ]
          }
          }/>
        </section>
        <section className="frequently-asked-questions">          
          <TestimonialsSection { ...{
            heading:{
              title:"TESTIMONIALS",
              heading:"Hear from our Ambassadors",
              body: "What it's like to work with our team."
            },
            testimonials:[
                {
                  quote: doubleQuote(
                    "After meeting Tennr last year at VGM Heartland, I was very excited to partner with them to offer their automation platform to all my DME and Sleep Clients. Tennr is the fastest growing company working to automate your business workflows and has exceeded my customers' expectations."
                  ),
                  image: "/img/chris-holt.png",
                  attributedTo: "Phil Kneifel",
                  attributedToTitle: "President at Midwest Medical",
                },
                {
                  quote: doubleQuote(
                    "Tennr’s machine learning solutions enable our members to achieve greater efficiency with less effort, allowing staff to be reallocated to more meaningful roles. Their innovative offerings drive productivity and foster significant growth for our members’ businesses."
                  ),
                  image: "/img/khalid-elawad.png",
                  attributedTo: "Dave Lyman",
                  attributedToTitle: "SVP of Customer Success at VGM & Associates ",
                },
                {
                  quote: doubleQuote("Tennr involves uncovering untapped opportunities within healthcare operations, such as optimizing patient flow, boosting revenue, and enhancing overall service delivery. By partnering with Tennr, I aim to provide data-driven insights and strategic recommendations to help clients leverage."),
                  image: "/img/sydney-gil.png", 
                  attributedTo: "Michael Kemp",      
                  attributedToTitle: "CEO at Kemp Holdings",
                },
              ],
              images:true
          }
          }/>
        </section>
        <section className="partner-portal">
          <Heading className="kit-heading" {...{
              title:"Partner Portal",
              heading: "Already a Partner?" ,
              body: "Log in to the partner portal",
              position:"center",
            }
          }/>
          <Link to="/" target="_blank">
            <Button {...{
                text: "Log In",
                background: "#9B4E45",
                width: 250,
                height: 58,
                textFromColor: "#FBFBF9",
              }
            }/>
          </Link>
        </section>
      </main>
      <SiteFooter bgImage="/img/footer-bg.jpg" bgImageVert="/img/footer-bg-vert.jpg" />
    </>
  );
};
